import { render, staticRenderFns } from "./FAQContent.vue?vue&type=template&id=7a8f88c0&scoped=true"
import script from "./FAQContent.vue?vue&type=script&lang=js"
export * from "./FAQContent.vue?vue&type=script&lang=js"
import style0 from "./FAQContent.vue?vue&type=style&index=0&id=7a8f88c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f88c0",
  null
  
)

export default component.exports